export default __webpack_public_path__ + "static/media/couple.f6d1d62f.jpg";